<template>
    <BaseSection class="video-grid-section">
        <template v-if="title" #title>{{ title }}</template>
        <template #default>
            <VideoCardList
                appearance="hybrid"
                :videos="videos"
            />
        </template>
    </BaseSection>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: ''
    },
    videos: {
        type: Array,
        default: () => []
    }
});
</script>

<style lang="less">
.video-grid-section {
    padding-top: var(--spacing-lg);

    @media @q-md-min {

        padding-top: var(--spacing-xl);
    }
}
</style>
